import { render } from "./ReviewForm.vue?vue&type=template&id=5263c9e7&scoped=true"
import script from "./ReviewForm.vue?vue&type=script&lang=js"
export * from "./ReviewForm.vue?vue&type=script&lang=js"

import "./ReviewForm.vue?vue&type=style&index=0&id=5263c9e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5263c9e7"]])

export default __exports__